import React from 'react';
import styled from 'styled-components/macro';
/**
 * Una gráfica de barra que muestra en color el porcentaje que se le pase
 * como width
 */

const Barras = ({ width, float = 'left', fill, height }) => (
  <Background height={height}>
    <Fill style={{ backgroundColor: fill, width }} float={float} />
  </Background>
);

const Fill = styled(({ float, ...rest }) => <div {...rest} />)`
  height: 100%;
  float: ${({ float }) => float};
`;
const Background = styled.div`
  width: 100%;
  height: ${({ height }) => (height ? height : '5px')};
  background-color: #e1e1dd;
`;

export default Barras;
